import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import SafeIcon from '../common/SafeIcon'
import * as FiIcons from 'react-icons/fi'

const { FiPenTool, FiHeart } = FiIcons

const Footer = () => {
  return (
    <motion.footer 
      className="bg-gray-900 text-white py-12"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="flex items-center justify-center space-x-3 mb-6">
            <img 
              src="/logos/professional-signature-logo-PNG-Icon-Only-White.png" 
              alt="Professional Signature Logo" 
              className="h-16 w-16"
            />
            <span className="text-xl font-display font-bold">
              Professional Signature
            </span>
          </div>
          
          <div className="flex flex-wrap justify-center space-x-8 mb-6 text-gray-300">
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
            <Link to="/contact" className="hover:text-white transition-colors">Contact Us</Link>
          </div>
          
          <div className="border-t border-gray-800 pt-6">
            <p className="text-gray-400 mb-2">
              © 2025 ProfessionalSignature.com
            </p>
            <p className="text-gray-500 flex items-center justify-center space-x-1">
              <span>Built with</span>
              <SafeIcon icon={FiHeart} className="text-red-500" />
              <span>and AI</span>
            </p>
          </div>
        </div>
      </div>
    </motion.footer>
  )
}

export default Footer